import VTour from './VTour'
import VStep from './VStep'

export default {
    // The install method will be called with the Vue constructor as
    // the first argument, along with possible options
    install (Vue, options) {
        Vue.component(VTour.name, VTour)
        Vue.component(VStep.name, VStep)

        Vue.prototype.$tours = {}
    }
}